export default __webpack_public_path__ + "static/media/checkbox_active.23631bcb.svg";